import React from 'react';

const TextareaComponent = ({ label, value, onChange, required }) => (
  <>
    <label className="form-label">
      {label}
      {required && <span className="req">*</span>}
    </label>
    <textarea
      className="form-textarea"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
    />
  </>
);

export default TextareaComponent;
